import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import { useEffect, useRef, useState } from 'react';
import styled from '@xstyled/styled-components';
import { Radio } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { LoadingSpinner, PrimaryButton, SecondaryButton, getSize, getColor } from '@lib/common';
import { SectionStatus, RequestStatus, SectionDisplayType } from '@module/form';
import { Size } from '@module/file-storage';
import { AudioFileEdit, AudioFileContainerDirection } from '../audio-file';
import { useSectionEditing, useSectionForm, useSectionAudio } from './hooks';
import { CardLayout, CardTitle, CardDescription, CardActions, StyledCardContainer, StyledGroupButton, StyledAudioWrapper } from '../shared'; // Types

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSectionSettingsCard = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  padding: ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), getColor('fillBgSub'), getColor('shapeBorder'), getSize('radiusS'), getSize('padding16'), getSize('padding16'), getSize('padding16'));
var SettingsHeader = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  margin-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n\n  .anticon {\n    font-size: 16px;\n    color: ", ";\n  }\n"])), getSize('padding8'), getSize('padding16'), getColor('contentHeading'), getSize('typo14'), getColor('contentBody'));
var SettingsConfigLabel = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n"])));
var SettingsTitle = styled.h4(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin: 0 0 ", " 0;\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n"])), getSize('padding12'), getSize('typo14'), getColor('contentHeading'));
var DisplayOptionCard = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: ", ";\n  padding: 12px;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  margin-bottom: ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  .ant-radio {\n    top: 3px;\n  }\n\n  .ant-radio-inner {\n    width: 18px;\n    height: 18px;\n    background-color: #f8fafc;\n    border-color: #cbd5e1;\n  }\n\n  .ant-radio-checked .ant-radio-inner {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  .ant-radio-checked .ant-radio-inner::after {\n    background-color: ", ";\n  }\n"])), getSize('padding12'), function (props) {
  return props.$selected ? '#faf8fc' : '#ffffff';
}, function (props) {
  return props.$selected ? getColor('fillIntActive') : '#cbd5e1';
}, getSize('padding8'), getSize('padding8'), getColor('fillIntActive'), getColor('fillIntActive'), getColor('fillBgWhite'), getColor('fillIntActive'));
var OptionTextWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n"])));
var OptionTitle = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n"])), getSize('typo14'), getColor('contentHeading'));
var OptionDescription = styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 13px;\n  color: ", ";\n  line-height: 1.4;\n"])), getColor('contentBody'));
var StyledRadioGroup = styled(Radio.Group)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var SectionV2Edit = function SectionV2Edit(_ref) {
  var _section$id;

  var section = _ref.section,
      sectionLabel = _ref.sectionLabel,
      isOnlyRemainingSection = _ref.isOnlyRemainingSection,
      _ref$hasSpeakingQuest = _ref.hasSpeakingQuestion,
      hasSpeakingQuestion = _ref$hasSpeakingQuest === void 0 ? false : _ref$hasSpeakingQuest,
      onUpdateSection = _ref.onUpdateSection,
      onSaveSection = _ref.onSaveSection,
      onCancel = _ref.onCancel,
      onDeleteSection = _ref.onDeleteSection,
      addSectionFileStatus = _ref.addSectionFileStatus,
      file = _ref.file,
      onResetAddSectionFileUseCase = _ref.onResetAddSectionFileUseCase,
      onShowingUploadSectionFileModal = _ref.onShowingUploadSectionFileModal,
      onShowingUploadSectionAudioFileModal = _ref.onShowingUploadSectionAudioFileModal,
      onDeletingAudioFile = _ref.onDeletingAudioFile,
      saveSectionStatus = _ref.saveSectionStatus,
      editorLabels = _ref.editorLabels;

  if (!section) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  } // Get section ID


  var sectionId = (section === null || section === void 0 ? void 0 : (_section$id = section.id) === null || _section$id === void 0 ? void 0 : _section$id.toString()) || ''; // In edit mode, title and description are always editable

  var isTitleEditing = true;
  var isDescriptionEditing = true;

  var _useState = useState(),
      openPopoverSectionId = _useState[0],
      setOpenPopoverSectionId = _useState[1]; // Hooks


  var editing = useSectionEditing({
    section: section,
    sectionLabel: sectionLabel,
    readonly: false,
    onUpdateSection: onUpdateSection
  });
  var form = useSectionForm({
    section: section,
    localTitle: editing.localTitle,
    localDescription: editing.localDescription,
    sectionLabel: sectionLabel,
    onUpdateSection: onUpdateSection
  });
  var richTextEditorRef = useRef(null);

  var _useSectionAudio = useSectionAudio({
    section: section
  }),
      audioFile = _useSectionAudio.audioFile,
      audioLabel = _useSectionAudio.audioLabel; // Track if we've already initialized the new section


  var hasInitializedNewSection = useRef(false);
  var handleTitleFocusRef = useRef(editing.handleTitleFocus); // Add image to rich text editor when upload succeeds

  useEffect(function () {
    if (addSectionFileStatus === RequestStatus.SUCCESS && file && file.url) {
      if (richTextEditorRef.current && typeof richTextEditorRef.current.insertImageHandler === 'function') {
        richTextEditorRef.current.insertImageHandler(file.url);
      }

      onResetAddSectionFileUseCase === null || onResetAddSectionFileUseCase === void 0 ? void 0 : onResetAddSectionFileUseCase();
    }
  }, [addSectionFileStatus, file, onResetAddSectionFileUseCase]); // Keep ref updated with latest function

  useEffect(function () {
    handleTitleFocusRef.current = editing.handleTitleFocus;
  }, [editing.handleTitleFocus]); // Auto focus title input when new section is created and scroll to it

  useEffect(function () {
    // Check if section is new (has status === New)
    var isNew = 'status' in section && (section === null || section === void 0 ? void 0 : section.status) === SectionStatus.New;

    if (isNew && !hasInitializedNewSection.current) {
      hasInitializedNewSection.current = true;
      var defaultTitle = (sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionTitle) || '';
      var defaultDescription = (sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.defaultSectionDescription) || '';

      if (onUpdateSection) {
        if (defaultTitle) {
          onUpdateSection('title', defaultTitle);
        }

        if (defaultDescription) {
          onUpdateSection('description', defaultDescription);
        }

        setTimeout(function () {
          onUpdateSection('status', SectionStatus.Activate.toString());
        }, 0);
      } // Scroll to the new section


      var scrollTimer = setTimeout(function () {
        var sectionElement = document.getElementById(sectionId);

        if (sectionElement) {
          sectionElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }, 100); // Focus title input

      var focusTimer = setTimeout(function () {
        handleTitleFocusRef.current();
      }, 200);
      return function () {
        clearTimeout(scrollTimer);
        clearTimeout(focusTimer);
      };
    }

    if (!isNew) {
      hasInitializedNewSection.current = false;
    }
  }, [section, sectionLabel, onUpdateSection, sectionId]);

  var handleDisplayTypeChange = function handleDisplayTypeChange(targetValue) {
    editing.handleDisplayTypeChange(targetValue);
  }; // Handle save button click - update both fields together and call onSaveSection


  var handleSaveSection = function handleSaveSection() {
    var _editing$localTitle;

    // Get the latest values
    // Check if title is empty or whitespace only, use 'current' as default when saving/creating
    var trimmedTitle = ((_editing$localTitle = editing.localTitle) === null || _editing$localTitle === void 0 ? void 0 : _editing$localTitle.trim()) || '';
    var titleToSave = trimmedTitle || 'current'; // Allow empty description - don't set default

    var descriptionToSave = editing.localDescription || '';
    var cleanedDescription = descriptionToSave.replace(/^<p>|<\/p>$/g, '');
    onSaveSection === null || onSaveSection === void 0 ? void 0 : onSaveSection(titleToSave, cleanedDescription, editing.localDisplayType);
  }; // Handle cancel - reset local changes


  var handleCancel = function handleCancel() {
    editing.handleDescriptionCancel();
    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
  };

  return /*#__PURE__*/_jsxs(CardLayout, {
    isFocused: true,
    sectionId: sectionId,
    formProps: {
      form: form.form,
      name: 'section',
      initialValues: form.initialValues,
      onFieldsChange: form.onFieldsChange
    },
    children: [/*#__PURE__*/_jsxs(StyledCardContainer, {
      children: [/*#__PURE__*/_jsx(CardTitle, {
        tagLabel: (sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.section) || 'SECTION',
        title: editing.localTitle,
        isEditing: isTitleEditing,
        isReadonly: false,
        placeholder: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.placeholderSectionTitle,
        onChange: editing.handleTitleChange,
        onBlur: editing.handleTitleBlur,
        onFocus: editing.handleTitleFocus,
        onKeyDown: editing.handleTitleKeyDown,
        onClick: editing.handleTitleFocus,
        autoFocus: false
      }), /*#__PURE__*/_jsx(CardActions, {
        isOnlyRemainingSection: isOnlyRemainingSection,
        actions: ['delete', 'more'],
        onDelete: function onDelete(e) {
          e === null || e === void 0 ? void 0 : e.stopPropagation();
          onDeleteSection === null || onDeleteSection === void 0 ? void 0 : onDeleteSection();
        },
        openPopoverId: openPopoverSectionId,
        onPopoverChange: setOpenPopoverSectionId,
        sectionId: sectionId
      })]
    }), audioFile && /*#__PURE__*/_jsx(StyledAudioWrapper, {
      children: /*#__PURE__*/_jsx(AudioFileEdit, {
        source: audioFile.url,
        onEdit: onShowingUploadSectionAudioFileModal,
        fileName: '',
        fileSize: Size.format(audioFile.size),
        label: audioLabel,
        onDelete: onDeletingAudioFile,
        direction: AudioFileContainerDirection.HORIZONTAL
      }, audioFile.id.toString())
    }), /*#__PURE__*/_jsx(CardDescription, {
      description: editing.localDescription,
      isEditing: isDescriptionEditing,
      isReadonly: false,
      placeholder: editing.localDescription ? sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.placeholderSectionDescription : undefined,
      onChange: editing.handleDescriptionChange,
      hideButtons: true,
      editorLabels: editorLabels,
      onAddImage: function onAddImage() {
        return onShowingUploadSectionFileModal === null || onShowingUploadSectionFileModal === void 0 ? void 0 : onShowingUploadSectionFileModal(sectionId);
      },
      onAddAudio: onShowingUploadSectionAudioFileModal,
      richTextEditorRef: richTextEditorRef
    }), /*#__PURE__*/_jsxs(StyledSectionSettingsCard, {
      children: [/*#__PURE__*/_jsxs(SettingsHeader, {
        children: [/*#__PURE__*/_jsx(SettingOutlined, {}), /*#__PURE__*/_jsx(SettingsConfigLabel, {
          children: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.configuration
        })]
      }), /*#__PURE__*/_jsx(SettingsTitle, {
        children: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.questionDisplayMode
      }), /*#__PURE__*/_jsxs(StyledRadioGroup, {
        value: editing.localDisplayType,
        onChange: function onChange(e) {
          return handleDisplayTypeChange(e.target.value);
        },
        children: [/*#__PURE__*/_jsxs(DisplayOptionCard, {
          $selected: SectionDisplayType.isList(editing.localDisplayType),
          onClick: function onClick() {
            return handleDisplayTypeChange(SectionDisplayType.List);
          },
          children: [/*#__PURE__*/_jsx(Radio, {
            value: SectionDisplayType.List
          }), /*#__PURE__*/_jsxs(OptionTextWrapper, {
            children: [/*#__PURE__*/_jsx(OptionTitle, {
              children: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.listDisplayMode
            }), /*#__PURE__*/_jsx(OptionDescription, {
              children: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.listDisplayModeDesc
            })]
          })]
        }), /*#__PURE__*/_jsxs(DisplayOptionCard, {
          $selected: SectionDisplayType.isCarousel(editing.localDisplayType),
          onClick: function onClick() {
            return handleDisplayTypeChange(SectionDisplayType.Carousel);
          },
          children: [/*#__PURE__*/_jsx(Radio, {
            value: SectionDisplayType.Carousel
          }), /*#__PURE__*/_jsxs(OptionTextWrapper, {
            children: [/*#__PURE__*/_jsx(OptionTitle, {
              children: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.oneQuestionAtATime
            }), /*#__PURE__*/_jsx(OptionDescription, {
              children: sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.oneQuestionAtATimeDesc
            })]
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledGroupButton, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        onClick: handleCancel,
        children: (sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.cancel) || 'Cancel'
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        onClick: handleSaveSection,
        loading: saveSectionStatus === RequestStatus.EXECUTE,
        children: (sectionLabel === null || sectionLabel === void 0 ? void 0 : sectionLabel.save) || 'Save'
      })]
    })]
  });
};